// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eswitch_fpg_web--TabbedSection-module--TabHeader--gFASaEwTr9tJcajan0Xn {
  text-align: center;
  font-family: var(--fmc-font--ford-motion) !important;
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 52px;
}

.eswitch_fpg_web--TabbedSection-module--TabsContainer--rvGWnCa7myboo4Y5vaxs {
  margin: 4rem 0;
  background-color: white;
  margin-top: 10rem;
  margin-bottom: 10rem;
}

.eswitch_fpg_web--TabbedSection-module--TabText--gaZBnFl_4cJdq5_bqval {
  text-align: center;
  margin-top: 20px !important;
  font-size: 16px;
  font-style: normal;
  color: #4d4d4d !important;
  padding-bottom: 35px;
}

.eswitch_fpg_web--TabbedSection-module--BoxContainer--VM0egFs0aYf7wbCr4siy {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 40px;
  margin-bottom: 40px;
  padding-bottom: 2rem;
}

.eswitch_fpg_web--TabbedSection-module--BoxContainer--VM0egFs0aYf7wbCr4siy figure {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.eswitch_fpg_web--TabbedSection-module--BoxContainer--VM0egFs0aYf7wbCr4siy .eswitch_fpg_web--TabbedSection-module--ImageBox--RlQx8lkeHmxPrJ8M1Zmx {
  height: 120px;
  display: flex;
  align-items: flex-end;
}

.eswitch_fpg_web--TabbedSection-module--BoxContainer--VM0egFs0aYf7wbCr4siy .eswitch_fpg_web--TabbedSection-module--BoxTitle--u9cSJJqycTK16z8LtS_k {
  font-size: 24px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  margin-top: 15px;
}

.eswitch_fpg_web--TabbedSection-module--BoxContainer--VM0egFs0aYf7wbCr4siy .eswitch_fpg_web--TabbedSection-module--BoxText--jT7t_ARZ5FWqtYOBVSs9 {
  color: #4d4d4d !important;
  margin-top: 50px;
  width: 350px;
  text-align: center;
}

.eswitch_fpg_web--TabbedSection-module--TextButton--NW2L38UJ4VQGYMZECWAn {
  text-align: center;
  display: flex;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  justify-content: center;
}

.eswitch_fpg_web--TabbedSection-module--TextButton--NW2L38UJ4VQGYMZECWAn img {
  margin-left: 1rem;
}

.eswitch_fpg_web--TabbedSection-module--DialogContainer--fsmO9A9VXVL51v5Xgmcf {
  display: flex;
  gap: 20px;
}

.eswitch_fpg_web--TabbedSection-module--DialogContainer--fsmO9A9VXVL51v5Xgmcf .eswitch_fpg_web--TabbedSection-module--DialogBox--ovcMevDw6EnkyEUwYOGp {
  width: 50%;
  padding: 1rem;
  border: 1px solid rgba(0, 9, 91, 0.1098039216);
  border-radius: 0.5rem;
  box-shadow: 0.25rem 0.25rem 0.5rem rgba(0, 0, 0, 0.0588235294);
}

.eswitch_fpg_web--TabbedSection-module--DialogContainer--fsmO9A9VXVL51v5Xgmcf .eswitch_fpg_web--TabbedSection-module--DialogBox--ovcMevDw6EnkyEUwYOGp p {
  margin-top: 1rem;
  color: #4d4d4d !important;
}

.eswitch_fpg_web--TabbedSection-module--DialogContainer--fsmO9A9VXVL51v5Xgmcf .eswitch_fpg_web--TabbedSection-module--DialogBox--ovcMevDw6EnkyEUwYOGp .eswitch_fpg_web--TabbedSection-module--Actions--hwa7Hpxcp56dmmdTdOmV {
  margin-top: 20px;
  text-align: right;
}

.eswitch_fpg_web--TabbedSection-module--h3--VE3RFg8FNrQDTdHOavOk,
.eswitch_fpg_web--TabbedSection-module--h4--yAMSSFja6a1BXxqqaCKE {
  letter-spacing: 0 !important;
  font-family: var(--fmc-font--inter);
}

.eswitch_fpg_web--TabbedSection-module--h3--VE3RFg8FNrQDTdHOavOk {
  margin-bottom: 32px !important;
  font-family: var(--fmc-font--ford-motion) !important;
}

.eswitch_fpg_web--TabbedSection-module--p--VxAu4zuVv9VEkYB6KJa3 {
  color: var(--fds-color--gray3) !important;
  letter-spacing: 0 !important;
  font-family: var(--fmc-font--inter);
}

.eswitch_fpg_web--TabbedSection-module--headerText--vCOXctJONUnEPBIUDy9g {
  padding-top: 20px;
}

@media (max-width: 767px) {
  .eswitch_fpg_web--TabbedSection-module--TabsContainer--rvGWnCa7myboo4Y5vaxs .eswitch_fpg_web--TabbedSection-module--tabContainer--YW3_R8wdfcFCsM7rSQ3G {
    align-items: center;
    flex-flow: column !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TabbedSection/TabbedSection.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,oDAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AACJ;;AAAI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAER;;AAAI;EACI,aAAA;EACA,aAAA;EACA,qBAAA;AAER;;AAAI;EACI,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AAER;;AAAI;EACI,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAER;;AACA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;AAEJ;;AADI;EACI,iBAAA;AAGR;;AAAA;EACI,aAAA;EACA,SAAA;AAGJ;;AAFI;EACI,UAAA;EACA,aAAA;EAEA,8CAAA;EACA,qBAAA;EACA,8DAAA;AAGR;;AADQ;EACI,gBAAA;EACA,yBAAA;AAGZ;;AADQ;EACI,gBAAA;EACA,iBAAA;AAGZ;;AAEA;;EAEI,4BAAA;EACA,mCAAA;AACJ;;AAEA;EACI,8BAAA;EACA,oDAAA;AACJ;;AAEA;EACI,yCAAA;EACA,4BAAA;EACA,mCAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EAEQ;IACI,mBAAA;IACA,4BAAA;EAAV;AACF","sourcesContent":[".TabHeader {\n    text-align: center;\n    font-family: var(--fmc-font--ford-motion) !important;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 48px;\n    line-height: 52px;\n}\n\n.TabsContainer {\n    margin: 4rem 0;\n    background-color: white;\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n}\n\n.TabText {\n    text-align: center;\n    margin-top: 20px !important;\n    font-size: 16px;\n    font-style: normal;\n    color: #4d4d4d !important;\n    padding-bottom: 35px;\n}\n\n.BoxContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    margin-top: 40px;\n    margin-bottom: 40px;\n    padding-bottom: 2rem;\n    figure {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n    .ImageBox {\n        height: 120px;\n        display: flex;\n        align-items: flex-end;\n    }\n    .BoxTitle {\n        font-size: 24px;\n        font-family: 'Inter', sans-serif;\n        font-weight: 500;\n        margin-top: 15px;\n    }\n    .BoxText {\n        color: #4d4d4d !important;\n        margin-top: 50px;\n        width: 350px;\n        text-align: center;\n    }\n}\n.TextButton {\n    text-align: center;\n    display: flex;\n    margin-bottom: 2rem;\n    padding-bottom: 2rem;\n    justify-content: center;\n    img {\n        margin-left: 1rem;\n    }\n}\n.DialogContainer {\n    display: flex;\n    gap: 20px;\n    .DialogBox {\n        width: 50%;\n        padding: 1rem;\n\n        border: 1px solid #00095b1c;\n        border-radius: 0.5rem;\n        box-shadow: 0.25rem 0.25rem 0.5rem #0000000f;\n\n        p {\n            margin-top: 1rem;\n            color: #4d4d4d !important;\n        }\n        .Actions {\n            margin-top: 20px;\n            text-align: right;\n        }\n    }\n}\n\n.h3,\n.h4 {\n    letter-spacing: 0 !important;\n    font-family: var(--fmc-font--inter);\n}\n\n.h3 {\n    margin-bottom: 32px !important;\n    font-family: var(--fmc-font--ford-motion) !important;\n}\n\n.p {\n    color: var(--fds-color--gray3) !important;\n    letter-spacing: 0 !important;\n    font-family: var(--fmc-font--inter);\n}\n\n.headerText {\n    padding-top: 20px;\n}\n\n@media (max-width: 767px) {\n    .TabsContainer {\n        .tabContainer {\n            align-items: center;\n            flex-flow: column !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TabHeader": `eswitch_fpg_web--TabbedSection-module--TabHeader--gFASaEwTr9tJcajan0Xn`,
	"TabsContainer": `eswitch_fpg_web--TabbedSection-module--TabsContainer--rvGWnCa7myboo4Y5vaxs`,
	"TabText": `eswitch_fpg_web--TabbedSection-module--TabText--gaZBnFl_4cJdq5_bqval`,
	"BoxContainer": `eswitch_fpg_web--TabbedSection-module--BoxContainer--VM0egFs0aYf7wbCr4siy`,
	"ImageBox": `eswitch_fpg_web--TabbedSection-module--ImageBox--RlQx8lkeHmxPrJ8M1Zmx`,
	"BoxTitle": `eswitch_fpg_web--TabbedSection-module--BoxTitle--u9cSJJqycTK16z8LtS_k`,
	"BoxText": `eswitch_fpg_web--TabbedSection-module--BoxText--jT7t_ARZ5FWqtYOBVSs9`,
	"TextButton": `eswitch_fpg_web--TabbedSection-module--TextButton--NW2L38UJ4VQGYMZECWAn`,
	"DialogContainer": `eswitch_fpg_web--TabbedSection-module--DialogContainer--fsmO9A9VXVL51v5Xgmcf`,
	"DialogBox": `eswitch_fpg_web--TabbedSection-module--DialogBox--ovcMevDw6EnkyEUwYOGp`,
	"Actions": `eswitch_fpg_web--TabbedSection-module--Actions--hwa7Hpxcp56dmmdTdOmV`,
	"h3": `eswitch_fpg_web--TabbedSection-module--h3--VE3RFg8FNrQDTdHOavOk`,
	"h4": `eswitch_fpg_web--TabbedSection-module--h4--yAMSSFja6a1BXxqqaCKE`,
	"p": `eswitch_fpg_web--TabbedSection-module--p--VxAu4zuVv9VEkYB6KJa3`,
	"headerText": `eswitch_fpg_web--TabbedSection-module--headerText--vCOXctJONUnEPBIUDy9g`,
	"tabContainer": `eswitch_fpg_web--TabbedSection-module--tabContainer--YW3_R8wdfcFCsM7rSQ3G`
};
export default ___CSS_LOADER_EXPORT___;
